//Accordion
(function ($) {
    function accordionImage20() {

        $('.accordion-image-20').each(function(){
            const $parent = $(this);
            let accordionImageList = $(this).find('.accordion-image-20__items-list');

            accordionImageList.each(function () {
                let accordionImageItem = $(this).find('.accordion-image-20__item');

                accordionImageItem.on('click', function (e) {
                    const key = ($(this).data('key'));
                    if ($(this).hasClass('active')) {
                        e.preventDefault();
                        if ($(this).hasClass('active') && window.innerWidth <= 768) {
                            $(this).find('.accordion-image-20__item-content').slideUp(300);
                            $(this).removeClass('active');
                            $parent.find('.accordion-image-20 video').each(function () {
                                if (!this.paused) {
                                    this.pause();
                                    this.currentTime = 0;
                                }
                            });
                        }
                    } else {
                        $parent.find('.accordion-image-20__item').removeClass('active');
                        $(this).addClass('active');
                        $parent.find('.accordion-image-20__image-column .image-wrapper').removeClass('active');
                        $parent.find(`.accordion-image-20__image-column .image-wrapper[data-key="${key}"]`).addClass('active');
                        $parent.find('.accordion-image-20__item-content').slideUp(300);
                        $(this).find('.accordion-image-20__item-content').slideDown(300);

                        $parent.find('video').each(function () {
                            if (!this.paused) {
                                this.pause();
                            }
                            setTimeout(()=> {
                                this.currentTime = 0;
                            }, 10);
                        });

                        if (window.innerWidth <= 768) {
                            setTimeout(() => {
                                $("html, body").animate({
                                    scrollTop: $(this).offset().top - 100
                                }, 500);
                            }, 300);
                            const video = $parent.find(`.accordion-image-20__items-column .accordion-image-20__image-wrapper[data-key="${key}"]`).find('video[data-autoplay="true"]');
                            video[0]?.play();
                        } else {
                            const video = $parent.find(`.accordion-image-20__image-column .image-wrapper[data-key="${key}"]`).find('video[data-autoplay="true"]');
                            video[0]?.play();
                        }
                    }
                })
            })
        });
    }

    accordionImage20();

    $(document).ready(function(){
        $('.accordion-image-20 video:not([data-autoplay="true"])').attr('controls', 'controls');
        $('.accordion-image-20 video[data-autoplay="true"]:visible')[0]?.play();
    });
})(jQuery);